"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authModule = void 0;
const signInWithProviderModalModule_1 = require("root/src/client/web/auth/descriptions/modules/signInWithProviderModalModule");
const transformToCreatorModalModule_1 = require("root/src/client/web/auth/descriptions/modules/transformToCreatorModalModule");
exports.authModule = Object.assign(Object.assign({}, signInWithProviderModalModule_1.signInWithProviderModalModule), transformToCreatorModalModule_1.transformToCreatorModalModule);
